import { render, staticRenderFns } from "./postres.vue?vue&type=template&id=c621b2cc&scoped=true&"
import script from "./postres.vue?vue&type=script&lang=js&"
export * from "./postres.vue?vue&type=script&lang=js&"
import style0 from "./postres.vue?vue&type=style&index=0&id=c621b2cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c621b2cc",
  null
  
)

export default component.exports